module.exports = __webpack_public_path__ + "img/icon-checkbox-green.376e8914.svg";